/* eslint-disable import/no-unused-modules */
export const isFirefox = () =>
    typeof navigator !== 'undefined' && /firefox/i.test(navigator.userAgent);
